// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__qtLXK","boxTitle":"Qualiphy_boxTitle__x3x5I","box":"Qualiphy_box__3vm4w","toggleWrap":"Qualiphy_toggleWrap__3hlHw"};